<template>
  <v-dialog v-model="dialogState" persistent max-width="600px">
    <v-card>
      <v-toolbar color="accent" fixed>
        <v-toolbar-title>
          <v-icon left class="mt-n1">mdi-delete</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.delete") }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-3">
        <h3>{{ $vuetify.lang.t("$vuetify.action.delete_confirm") }}</h3>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closePopup">
          <v-icon class="mr-3">mdi-close</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.cancel") }}
        </v-btn>
        <v-btn
          :loading="isSubmitting"
          :disabled="!news || !news.id || isSubmitting"
          @click="removeNews"
        >
          <v-icon class="mr-3">mdi-delete</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "@/services/api";
export default {
  data: function() {
    return {
      dialogState: false,
      isSubmitting: false,
    };
  },
  methods: {
    closePopup() {
      this.dialogState = false;
      this.$emit("closeRemoveNewsPopup");
    },
    removeNews() {
      if (!this.news || !this.news.id || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      Api.article("delete", this.news.id)
        .then((data) => {
          this.closePopup();
          this.$emit("reload", data);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
  watch: {
    removeNewsPopup(newVal) {
      this.dialogState = newVal;
    },
  },
  props: {
    removeNewsPopup: {
      type: Boolean,
      default: false,
    },
    news: {
      type: Object,
      default: null,
    },
  },
};
</script>
